// ============================================================================
// Doc Order — business constants (ops-confirmed; port of the handoff's
// window.DO_CONFIG plus doc-order rollout constants). Pure module.
// ============================================================================

export const DO_CONFIG = {
  /** Flat $ deducted from LO net payout — must equal bankerReconService EO_INSURANCE. */
  eoInsurance: 50,
  /** Default amount on the auto-injected Trust Review Fee; payee starts blank. */
  trustReviewFeeDefault: 250,
  /** First payment = doc month + N. */
  firstPaymentOffsetMonths: 2,
  /** "Fund into" allowed only when funding ≤ N days into the next month. */
  fundIntoCutoffDays: 5,
  /** Estimated Settlement Statement flagged stale after N days. */
  essStaleDays: 21,
  /** Title Commitment flagged when older than N days at closing. */
  titleShelfLifeDays: 120,
  /** Warn when the policy expires < N days after funding (refis only). */
  insuranceExpirationBufferDays: 60,
  closingDistroEmail: 'closing@lendwisemtg.com',
  lockDeskEmail: 'lockdesk@lendwisemtg.com',
  /** Annual hazard premium fallback = Field 230 (monthly) × this (doc-read first). */
  hazardAnnualFromMonthlyMultiplier: 12,
} as const;

/** Money-comparison tolerances (handoff A5). */
export const DO_TOLERANCE = {
  /** Invoice-vs-fee discrepancy. */
  discrepancy: 0.01,
  /** Cost-to-cure / marked-delta comparisons. */
  costToCure: 0.005,
} as const;

/** Encompass-fact snapshot considered stale after this many minutes (open triggers async refresh). */
export const DO_SNAPSHOT_STALE_MINUTES = 15;

/** DB feature flag gating the whole feature (default OFF). */
export const DO_FEATURE_FLAG = 'doc_order_v1';

/** The only loan channel the Doc Order tab is available on (Field 2626 — ops #10). */
export const DO_REQUIRED_CHANNEL = 'Banked - Retail';

export function isDocOrderChannel(channel: string | null | undefined): boolean {
  return /banked\s*-?\s*retail/i.test(channel ?? '');
}

/** Loss-payee clause the HOA-master AI read verifies (condo subject properties). */
export const DO_LENDWISE_LOSS_PAYEE =
  'Lendwise Mortgage Inc. ISAOA, 21800 Oxnard Rd #220, Woodland Hills, CA 91367';

/** Annual premium from the monthly Field 230 value (fallback when no doc read). */
export function annualPremiumFromMonthly(monthly: number | null | undefined): number {
  return (Number(monthly) || 0) * DO_CONFIG.hazardAnnualFromMonthlyMultiplier;
}

/**
 * R4 supplemental loan-field pulls (NON-GENERATED home — field-map.ts is
 * generated from the handoff and must not be hand-edited; the handoff map
 * carries no Field 1401). loanProgram1401 is the DSCR program SIGNAL for the
 * Snapshot's DTI↔DSCR swap; the displayed lock product stays
 * rate_lock_loan_program.
 */
export const DO_SUPPLEMENTAL_LOAN_FIELDS = {
  loanProgram1401: '1401',
  /** R5 #4 — CD received date (3978); clears Initial CD alongside 3977 and
   *  takes display precedence ("Received {3978}" over "Sent {3977}"). */
  cdReceivedDate: '3978',
} as const;
